import { APP_BASE_HREF } from '@angular/common';

import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule } from '@angular/common/http';
import { FormsModule } from '@angular/forms';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { GoogleMapsModule } from '@angular/google-maps';
import { GoogleChartsModule } from 'angular-google-charts';

// USWDS components
import { UsaRadioModule } from '@gsa-sam/ngx-uswds';

import { HomeComponent } from './home/home.component';
import { AboutMeComponent } from './about-me/about-me.component';
import { AboutMyHomeComponent } from './about-my-home/about-my-home.component';
import { AboutMyDayComponent } from './about-my-day/about-my-day.component';
import { ResultsComponent } from './results/results.component';
import { AboutMyLocationComponent } from './about-my-location/about-my-location.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    AboutMeComponent,
    AboutMyHomeComponent,
    AboutMyDayComponent,
    ResultsComponent,
    AboutMyLocationComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    GoogleMapsModule,
    GoogleChartsModule,
    HttpClientModule,
    FormsModule,
    UsaRadioModule
  ],
  providers: [
    { provide: APP_BASE_HREF, useValue: '/aboutepa/tracmyair/' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
